import { RightProps } from './Types'
import Styles from './MobileTopBarContainer.module.scss'

export const Right = ({ children, ...props }: RightProps) => {
  return (
    <div className={Styles.right} data-theme={props['data-theme']}>
      {children}
    </div>
  )
}
